<!-- Organization dialog Page @check="handleCheck"  -->
<template>
  <el-dialog
    :title="title"
    :visible.sync="addVisible"
    width="700px"
    @open="dlgOpen"
    @close="closeDialog"
    @closed="dlgClosed"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
  >
    <div :style="dlgBody" v-if="addVisible">
      <div class="treeLeft">
        <el-container style="height:100%">
          <el-header style="height:auto;">
            <el-input placeholder="输入关键字进行过滤" v-model.trim="filterText"></el-input>
          </el-header>
          <el-main style="height:100%;padding:8px;width:100%">
            <el-tree
              v-if="operType!=1"
              class="filter-tree"
              :props="defaultProps"
              :load="loadNode"
              lazy
              :filter-node-method="filterNode"
              node-key="id"
              :default-checked-keys="defaultCheckedKeys"
              :expand-on-click-node="false"
              :highlight-current="highlightCurrent"
              :default-expanded-keys="defaultExpandedKeys"
              @node-click="handleNodeClick"
              ref="orgTreeDlg"
            >
              z
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.level==0">
                  <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else-if="data.level==1">
                  <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else>
                  <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
              </span>
            </el-tree>

            <el-tree
              v-if="operType==1"
              class="filter-tree"
              :data="treeData"
              :props="defaultProps"
              :filter-node-method="filterNode"
              node-key="id"
              :default-checked-keys="defaultCheckedKeys"
              :expand-on-click-node="false"
              @node-click="handleNodeClick"
              :default-expanded-keys="defaultExpandedKeys"
              ref="orgTreeDlg"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span v-if="data.level==0">
                  <span class="fa fa-folder-open fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else-if="data.level==1">
                  <span class="fa fa-folder-open-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
                <span v-else>
                  <span class="fa fa-folder-o fa-fw">&nbsp;{{node.label}}</span>
                </span>
              </span>
            </el-tree>
          </el-main>
        </el-container>
      </div>
      <div class="treeMiddle"></div>
      <!-- <div class="treeRight" v-if="rightRoomShow">
        <el-container style="height:100%">
          <el-header style="height:auto;">
            <el-input placeholder="输入关键字进行过滤" v-model.trim="filterTableText"></el-input>
          </el-header>
          <el-main style="height:100%;padding:8px;width:100%">
            <el-table
              size="medium"
              :data="roomsData"
              :show-header="false"
              style="width: 100%"
              ref="multipleTable"
              @select="handleSelect"
            >
              <el-table-column label v-if="multipleStatus==0">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.row.room_id"
                    v-model.trim="participantRadio"
                    @change.native="getDataRow(scope.$index,scope.row)"
                  >{{scope.row.name}}</el-radio>
                </template>
              </el-table-column>
              <el-table-column type="selection" width="48" v-if="multipleStatus==1"></el-table-column>
              <el-table-column label v-if="multipleStatus==1">
                <template slot-scope="scope">{{scope.row.name}}</template>
              </el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </div>-->
      <div class="treeRight">
        <el-container style="height:100%">
          <el-header style="height:auto;">
            <el-input placeholder="输入关键字进行过滤" v-model.trim="filterTableText"></el-input>
          </el-header>
          <!-- <el-checkbox
            :indeterminate="isIndeterminate"
            v-model.trim="checkAll"
            @change="handleCheckAllChange"
          >全选</el-checkbox>-->
          <el-main style="height:100%;padding:8px;width:100%">
            <el-table
              size="medium"
              :data="participantsData"
              :show-header="false"
              style="width: 100%"
              ref="multipleTable"
              @select="handleSelect"
            >
              <el-table-column label v-if="multipleStatus==0">
                <template slot-scope="scope">
                  <el-radio
                    :label="scope.row.id"
                    v-model.trim="participantRadio"
                    @change.native="getDataRow(scope.$index,scope.row)"
                  >{{scope.row.userName}}</el-radio>
                </template>
              </el-table-column>
              <el-table-column type="selection" width="48" v-if="multipleStatus==1"></el-table-column>
              <el-table-column label v-if="multipleStatus==1">
                <template slot-scope="scope">{{scope.row.userName}}</template>
              </el-table-column>
            </el-table>
          </el-main>
          <el-footer style="height:auto">
            <el-pagination
              ref="pageRef"
              layout="prev, pager, next"
              small
              :current-page="currentPage"
              :page-size="pageSize"
              :total="pageTotal"
              @current-change="handleCurrentChange"
            ></el-pagination>
          </el-footer>
        </el-container>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onCancel()">取 消</el-button>
      <el-button type="primary" @click="onSubmit('')" :disabled="btnDisabled">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
/** Dialog 自适应高度JS */
import DialogResize from "@/utils/DialogResize.js";
import Utils from "@/utils/Utils.js";
export default {
  mixins: [DialogResize],
  data() {
    return {
      btnDisabled: false,
      checkAll: false,
      isIndeterminate: true,
      /** 组织类型 0 全部 1 分部 2部门 */
      orgType: "",
      /** 右侧类型 1会场 2人员 */
      operType: 1,
      title: "",
      filterText: "",
      filterTableText: "",
      companyKeyWord: "",
      parentId: "",
      /** 分页 */
      currentPage: 1,
      pageSize: 50,
      pageTotal: 0,
      /** 是否高亮显示左侧选中 */
      highlightCurrent: true,
      /** 是否多选 */
      multipleStatus: 0,
      currentDeptOrParticipantId: "",
      currentSubcompanyId: "",
      /** radio  */
      participantRadio: "",
      addVisible: false,
      rightContactShow: false,
      rightRoomShow: false,
      callData: [],
      cacheData: {},
      treeData: [],
      defaultCheckedKeys: [],
      defaultRightCheckeKeys: [],
      /** 默认展开的节点 */
      defaultExpandedKeys: [],
      roomsData: [],
      participantsData: [],
      defaultProps: {
        children: "subs",
        label: "name",
        isLeaf: "leaf"
      }
    };
  },
  watch: {
    filterText(val) {
      this.$refs.orgTreeDlg.filter(val);
    },
    filterTableText(val) {
      setTimeout(() => {
        this.currentSubcompanyId = 0;
        this.currentDeptOrParticipantId = 0;
        this.highlightCurrent = false;
        if (this.$refs.pageRef) {
          this.currentPage = 1;
          this.$refs.pageRef.lastEmittedPage = 1;
        }
        this.initOperTypeData(val);
      }, 500);
    }
  },
  methods: {
    init(type, defaultId, useType, isMultiple, defaultRightCheckeKeys) {
      this.btnDisabled = false;
      this.addVisible = true;
      this.highlightCurrent = true;
      this.currentPage = 1;
      this.filterText = "";
      this.filterTableText = "";
      this.multipleStatus = isMultiple;
      this.defaultRightCheckeKeys = defaultRightCheckeKeys;
      /** radio  */
      this.participantRadio = "";
      this.currentDeptOrParticipantId = 0;
      this.currentSubcompanyId = 0;
      this.defaultExpandedKeys = [];
      this.roomsData = [];
      this.participantsData = [];
      this.cacheData = {};
      this.operType = type;
      //   this.operType = useType;

      if (this.operType == 1) {
        this.title = "选择公司-联系人";
        this.initType1Data();
      } else if (this.operType == 2) {
        this.title = "选择部门";
      } else {
        this.title = "选择组织架构";
      }

      // if (this.operType == 1) {
      //   this.title += "-会场";
      //   this.rightRoomShow = true;
      //   this.rightContactShow = false;
      // } else if (this.operType == 2) {
      //   this.title += "-联系人";
      //   this.rightContactShow = true;
      //   this.rightRoomShow = false;
      // }

      if (defaultId) {
        this.defaultCheckedKeys.push(defaultId);
      }
      this.callData = [];
    },
    loadNode(node, resolve) {
      if (node.level === 0) {
        if (this.orgType == 0) {
          this.initType0Data("", "", resolve, true);
        } else if (this.orgType == 2) {
          this.initType2Data("", "", resolve, true);
        }
        return;
      }
      setTimeout(() => {
        if (this.orgType == 0) {
          this.initType0Data(node.data.type, node.data.id, resolve, false);
        } else if (this.orgType == 2) {
          this.initType2Data(node.data.type, node.data.id, resolve, false);
        }
      }, 500);
    },
    initType0Data(type, deptId, resolve, isFirst) {
      this.$mhttp
        .httpGet(this.$constant.API_NSC + "uc/dept/currentUserDept", null, null)
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            let tranferData = [];
            if (this.orgType == 3) {
              tranferData = this.deepTraversal(res.data.data);
            } else {
              if (
                Object.keys(param).length == 0 ||
                (param.hasOwnProperty("v") && Object.keys(param).length == 1)
              ) {
                tranferData.push(res.data.data);
              } else {
                tranferData = res.data.data;
              }
            }
            if (res.data.data) {
              this.defaultExpandedKeys.push(res.data.data.id);
            }
            this.treeData = tranferData;
            resolve(this.treeData);
            if (isFirst) {
              this.initContactsData("");
            }
          } else {
            this.$message.error(res.data.msg);
            resolve([]);
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
        });
    },
    initType1Data() {
      this.btnDisabled = true;
      let param = {
        keyword: this.companyKeyWord
      };
      this.$mhttp
        .httpGet(this.$constant.API_NSC + "uc/dept/depts/company", param, null)
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            this.btnDisabled = false;
            this.treeData = res.data.data;
            this.parentId = res.data.data[0].id;
            if (res.data.data) {
              this.defaultExpandedKeys.push(res.data.data[0].id);
            }
            this.initContactsData("");
          } else {
            this.btnDisabled = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.btnDisabled = false;
          this.$message.error(err);
        });
    },
    initType2Data(type, deptId, resolve, isFirst) {
      this.$mhttp
        .httpGet(this.$constant.API_NSC + "uc/dept/currentUserDept", null, null)
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            let tranferData = [];
            tranferData = this.deepTraversal(res.data.data);
            this.treeData = tranferData;
            if (res.data.data) {
              this.defaultExpandedKeys.push(res.data.data.id);
            }
            resolve(this.treeData);
            if (isFirst) {
              this.initContactsData("");
            }
          } else {
            this.$message.error(res.data.msg);
            resolve([]);
          }
        })
        .catch(err => {
          this.$message.error(err);
          resolve([]);
        });
    },
    initContactsData(searchValue) {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        keyword: searchValue
      };
      this.$mhttp
        .httpGet(
          this.$constant.API_NSC + "uc/user/users/page/" + this.parentId,
          param,
          null
        )
        .then(res => {
          if (this.$constant.BIZ_RESPONSE_CODE == res.data.code) {
            this.participantsData = res.data.data.data;
            this.pageTotal = res.data.data.totalElements;
            // 回写数据
            this.writeBackData();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.$message.error(err);
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.highlightCurrent && this.filterTableText != "") {
        this.initContactsData("");
      } else {
        this.initContactsData(this.filterTableText);
      }
    },
    writeBackData() {
      if (
        this.defaultRightCheckeKeys == null ||
        this.defaultRightCheckeKeys == undefined
      ) {
        return;
      }
      if (this.defaultRightCheckeKeys.length == 0) {
        return;
      }
      if (this.multipleStatus == 1) {
        if (this.operType == 1) {
          if (this.roomsData && this.roomsData.length > 0) {
            this.$nextTick(() => {
              this.roomsData.forEach(row => {
                if (this.checkExist(row.room_id)) {
                  this.$refs.multipleTable.toggleRowSelection(row);
                }
              });
            });
          }
        } else {
          if (this.participantsData && this.participantsData.length > 0) {
            this.$nextTick(() => {
              this.participantsData.forEach(row => {
                if (this.checkExist(row.user_id)) {
                  this.$refs.multipleTable.toggleRowSelection(row);
                }
              });
            });
          }
        }
      } else {
        if (this.operType == 1) {
          if (this.roomsData && this.roomsData.length > 0) {
            this.roomsData.forEach(row => {
              if (this.checkExist(row.room_id)) {
                this.participantRadio = row.room_id;
                this.callData = row;
              }
            });
          }
        } else {
          if (this.participantsData && this.participantsData.length > 0) {
            this.participantsData.forEach(row => {
              if (this.checkExist(row.user_id)) {
                this.participantRadio = row.user_id;
                this.callData = row;
              }
            });
          }
        }
      }
    },
    checkExist(val) {
      for (let i = 0, len = this.defaultRightCheckeKeys.length; i < len; i++) {
        if (val == this.defaultRightCheckeKeys[i]) {
          return true;
        }
      }
      return false;
    },
    /**  radio */
    getDataRow(index, row) {
      this.callData = row;
    },
    handleSelect(selection, row) {
      if (
        Utils.varToStr(this.currentSubcompanyId) == "" &&
        Utils.varToStr(this.currentDeptOrParticipantId) == ""
      ) {
        this.currentSubcompanyId = "0";
      }

      if (Utils.varToStr(this.currentSubcompanyId) != "") {
        this.cacheData[this.currentSubcompanyId] = selection;
      } else if (Utils.varToStr(this.currentDeptOrParticipantId) != "") {
        this.cacheData[this.currentDeptOrParticipantId] = selection;
      }
      this.initCacheData();
    },
    initCacheData() {
      this.defaultRightCheckeKeys = [];
      for (let prop in this.cacheData) {
        if (this.operType == 1) {
          for (let propData of this.cacheData[prop]) {
            if (this.defaultRightCheckeKeys.indexOf(propData.room_id) != -1) {
              continue;
            }
            this.defaultRightCheckeKeys.push(propData.room_id);
          }
        } else {
          for (let propData of this.cacheData[prop]) {
            if (this.defaultRightCheckeKeys.indexOf(propData.user_id) != -1) {
              continue;
            }
            this.defaultRightCheckeKeys.push(propData.user_id);
          }
        }
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    handleNodeClick(item, node, self) {
      console.log(item);
      this.highlightCurrent = true;
      if (this.$refs.pageRef) {
        this.currentPage = 1;
        this.$refs.pageRef.lastEmittedPage = 1;
      }

      if (item.disabled) {
        return;
      }
      // if (item.type == 1) {
      //   this.currentSubcompanyId = item.id;
      //   this.currentDeptOrParticipantId = "";
      // } else if (item.type == 2) {
      //   this.currentSubcompanyId = "";
      //   this.currentDeptOrParticipantId = item.id;
      // } else {
      // this.currentSubcompanyId = "";
      this.parentId = item.id;
      this.currentDeptOrParticipantId = item.id;
      // }
      this.initOperTypeData(null);
    },
    onSubmit(formName) {
      this.btnDisabled = true;
      if (this.multipleStatus == 1) {
        this.callData = [];
        for (let prop in this.cacheData) {
          this.callData = this.callData.concat(this.cacheData[prop]);
        }
      }

      if (!this.callData || this.callData.length == 0) {
        this.$message({
          showClose: true,
          message: "请至少选择一条记录",
          type: "warning",
          duration: 2000
        });
        return;
      }
      this.$emit("node-data", this.callData);
      this.defaultCheckedKeys = [];
      this.addVisible = false;
      this.btnDisabled = false;
    },
    onCancel() {
      this.defaultCheckedKeys = [];
      this.addVisible = false;
    },
    closeDialog() {
      this.defaultCheckedKeys = [];
      this.addVisible = false;
    },
    initOperTypeData(searchValue) {
      this.initContactsData(searchValue);
    },
    deepTraversal(node) {
      let nodes = [];
      if (node instanceof Array) {
        for (let i = 0, len = node.length; i < len; i++) {
          if (this.orgType == 2 && (!node[i].parent_id || node[i].type == 1)) {
            node[i].disabled = true;
          } else if (this.orgType == 3 && !node[i].parent_id) {
            node[i].disabled = true;
          }
          nodes.push(node[i]);
          this.deepTraversal(node[i]);
        }
      } else {
        if (this.orgType == 2 && (!node.parent_id || node.type == 1)) {
          node.disabled = true;
        } else if (this.orgType == 3 && !node.parent_id) {
          node.disabled = true;
        }
        nodes.push(node);
        let childrens = node.children;
        if (childrens == null || childrens == undefined) {
          childrens = [];
        }
        for (let i = 0, len = childrens.length; i < len; i++) {
          this.deepTraversal(childrens[i]);
        }
      }
      return nodes;
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.defaultCheckedKeys : [];
      this.isIndeterminate = false;
    }
  }
};
</script>

<style scoped>
.treeLeft {
  width: 385px;
  height: 100%;
  float: left;
}
.treeMiddle {
  width: 1px;
  height: 100%;
  float: left;
  margin-left: 5px;
  background: #dcdfe6;
}
.treeRight {
  width: 240px;
  height: 100%;
  float: left;
  margin-left: 3px;
}
</style>
